import React from 'react';

import { type Extension } from '../web-client';

interface RendererContextProps {
	appDomainName?: string;
	appId?: string;
	egress?: Extension['egress'];
	extensionType?: Extension['type'];
	forgeEnvironment?: Extension['environmentType'];
	forgeReactMajorVersion?: number;
	openNewTabAsPopupWindow?: boolean;
	properties?: Extension['properties'];
}

export const RendererContext: React.Context<RendererContextProps> =
	React.createContext<RendererContextProps>({});
